import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getCategoryPath, type HomeCategory } from "../../lib/categories";
import { contactLink } from "../../lib/site";

type BlankHeaderProps = {
  categories: HomeCategory[];
};

export function BlankHeader({ categories }: BlankHeaderProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const { label: contactLabel, href: contactHref, Icon: ContactIcon } = contactLink;

  // Close the mobile menu whenever the route changes.
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  const renderHomeLink = () => (
    <Link
      className="blank-home-link"
      aria-current={pathname === "/" ? "page" : undefined}
      to="/"
    >
      الرئيسية
    </Link>
  );

  const renderCategoryLinks = () =>
    categories.map((category) => {
      const path = getCategoryPath(category);
      return (
        <Link
          key={category.slug}
          aria-current={pathname === path ? "page" : undefined}
          to={path}
        >
          {category.label}
        </Link>
      );
    });

  return (
    <header className="blank-header">
      <div className="blank-container">
        <div className="blank-header-inner">
          {renderHomeLink()}

          <nav className="blank-nav" aria-label="أقسام الموقع">
            {renderCategoryLinks()}
          </nav>

          <a
            className="blank-contact-link"
            href={contactHref}
            aria-label={contactLabel}
            target="_blank"
            rel="noreferrer noopener"
          >
            <ContactIcon className="h-[18px] w-[18px]" strokeWidth={1.6} aria-hidden="true" />
          </a>

          <button
            type="button"
            className="blank-burger"
            aria-label={menuOpen ? "إغلاق القائمة" : "فتح القائمة"}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? (
              <X className="h-6 w-6" aria-hidden="true" />
            ) : (
              <Menu className="h-6 w-6" aria-hidden="true" />
            )}
          </button>
        </div>

        <nav
          className={`blank-mobile-nav ${menuOpen ? "is-open" : ""}`}
          aria-label="قائمة الجوال"
        >
          {renderHomeLink()}
          {renderCategoryLinks()}
        </nav>
      </div>

      <div className="blank-caret" aria-hidden="true" />
    </header>
  );
}
